import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const StepsWhite = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M10.826 2.314a6 6 0 0 0-5.654-.005L2 3.999l6 3.338 6-3.325-3.174-1.698Z"
      fill="#fff"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M2.009 7.701a6 6 0 0 0 2.928 5.14L8 14.668V7.333L2 4l.009 3.701Z"
      fill="#fff"
      fillRule="evenodd"
      opacity={0.8}
    />
    <path
      clipRule="evenodd"
      d="M8 7.333v7.334l3.063-1.825a6 6 0 0 0 2.928-5.14L14 4 8 7.333Z"
      fill="#fff"
      fillRule="evenodd"
      opacity={0.5}
    />
  </Icon>
));

export default StepsWhite;
